import { render, staticRenderFns } from "./StorageCallRecording.vue?vue&type=template&id=821f173c&"
import script from "./StorageCallRecording.vue?vue&type=script&lang=js&"
export * from "./StorageCallRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports